import { Check, Star } from "lucide-react";
import { COMPARISON } from "../../data/membership";

export const ComparisonCards = () => (
  <section className="py-16" data-testid="membership-comparison">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-white mb-10">
        Compare Your Options
      </h2>
      <div className="grid md:grid-cols-2 gap-6 max-w-4xl">
        {COMPARISON.map((plan) => (
          <div
            key={plan.key}
            data-testid={`plan-card-${plan.key}`}
            className={`rounded-xl p-8 border ${
              plan.highlight
                ? "bg-[#0d1526] border-blue-500/60 shadow-[0_0_50px_-12px_rgba(37,99,235,0.35)] relative"
                : "bg-[#121212] border-zinc-800"
            }`}
          >
            {plan.highlight && (
              <span className="absolute -top-3 left-6 inline-flex items-center gap-1 bg-blue-600 text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-sm">
                <Star className="h-3 w-3" /> Best Value
              </span>
            )}
            <h3 className="font-heading text-lg font-semibold text-white">{plan.title}</h3>
            <div className="mt-3 mb-1">
              <span className="font-heading text-4xl font-bold text-white">{plan.price}</span>
            </div>
            <p className="text-zinc-500 text-sm mb-5">{plan.period}</p>
            {plan.savings && (
              <p className={`text-sm font-semibold mb-5 ${plan.highlight ? "text-green-400" : "text-zinc-400"}`}>
                {plan.savings}
              </p>
            )}
            <ul className="space-y-2.5">
              {plan.features.map((f) => (
                <li key={f} className="flex items-start gap-2.5 text-sm text-zinc-300">
                  <Check className={`h-4 w-4 shrink-0 mt-0.5 ${plan.highlight ? "text-blue-400" : "text-zinc-600"}`} />
                  {f}
                </li>
              ))}
            </ul>
            {plan.highlight && (
              <a
                href="#enroll"
                data-testid="plan-card-join-button"
                className="mt-7 w-full inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white rounded-sm px-6 py-3 font-semibold transition-colors"
              >
                Join Now
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);
